
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[hid]",
      function () {
        return require("private-next-pages/[hid]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[hid]"])
      });
    }
  